import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Package, Truck, CheckCircle, Clock, Search, ChevronRight } from 'lucide-react';
import Header from './components/Header11';
import Footer from './components/Footer11';

const Orders11 = () => {
    const navigate = useNavigate();
    const [searchTerm, setSearchTerm] = useState('');

    const orders = [
        { id: 'VEER-2026-001', date: 'Mar 15, 2026', status: 'Delivered', statusColor: '#22C55E', items: [{ name: 'Royal Black Sherwani', size: '42', qty: 1, price: 24999, image: 'https://images.pexels.com/photos/2916387/pexels-photo-2916387.jpeg?auto=compress&cs=tinysrgb&w=400' }], total: 24999 },
        { id: 'VEER-2026-002', date: 'Mar 10, 2026', status: 'In Transit', statusColor: '#D97706', items: [{ name: 'Charcoal Nehru Jacket', size: 'L', qty: 1, price: 7499, image: 'https://images.pexels.com/photos/2681751/pexels-photo-2681751.jpeg?auto=compress&cs=tinysrgb&w=400' }, { name: 'Ivory Silk Kurta Set', size: 'M', qty: 1, price: 5999, image: 'https://images.pexels.com/photos/3224610/pexels-photo-3224610.jpeg?auto=compress&cs=tinysrgb&w=400' }], total: 13498 },
        { id: 'VEER-2026-003', date: 'Feb 28, 2026', status: 'Processing', statusColor: '#3B82F6', items: [{ name: 'Navy Formal Suit', size: '40', qty: 1, price: 18999, image: 'https://images.pexels.com/photos/1536619/pexels-photo-1536619.jpeg?auto=compress&cs=tinysrgb&w=400' }], total: 18999 },
    ];

    const filtered = searchTerm ? orders.filter(o => o.id.toLowerCase().includes(searchTerm.toLowerCase()) || o.items.some(i => i.name.toLowerCase().includes(searchTerm.toLowerCase()))) : orders;

    const getStatusIcon = (status) => {
        if (status === 'Delivered') return <CheckCircle size={16} />;
        if (status === 'In Transit') return <Truck size={16} />;
        return <Clock size={16} />;
    };

    return (
        <>
            <style>{`
                @import url('https://fonts.googleapis.com/css2?family=Oswald:wght@400;500;600;700&family=Source+Sans+3:wght@300;400;600&display=swap');
            `}</style>

            <div style={{ fontFamily: "'Source Sans 3', -apple-system, sans-serif" }} className="min-h-screen bg-[#1C1917]">
                <Header />

                <main className="pt-[100px] pb-16 px-4 sm:px-6">
                    <div className="max-w-[1000px] mx-auto">
                        <div className="mb-8">
                            <div className="w-10 h-0.5 mb-4" style={{ backgroundColor: '#D97706' }} />
                            <h1 className="text-3xl sm:text-4xl font-bold mb-6" style={{ fontFamily: "'Oswald', sans-serif", color: '#FAFAF9', textTransform: 'uppercase', letterSpacing: '2px' }}>YOUR ORDERS</h1>
                            <div className="relative max-w-md">
                                <Search size={18} style={{ position: 'absolute', left: '14px', top: '50%', transform: 'translateY(-50%)', color: '#A8A29E' }} />
                                <input
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                    placeholder="Search orders..."
                                    style={{ width: '100%', padding: '12px 16px 12px 44px', backgroundColor: '#292524', border: '1px solid #44403C', color: '#FAFAF9', fontFamily: "'Source Sans 3', sans-serif", fontSize: '14px', outline: 'none' }}
                                />
                            </div>
                        </div>

                        {filtered.length === 0 ? (
                            <div className="text-center py-20">
                                <Package size={48} style={{ color: '#44403C', margin: '0 auto 16px' }} />
                                <h2 className="text-xl font-semibold mb-2" style={{ fontFamily: "'Oswald', sans-serif", color: '#FAFAF9' }}>No orders found</h2>
                                <p className="text-sm mb-6" style={{ color: '#A8A29E' }}>Start shopping to see your orders here</p>
                                <button onClick={() => navigate('/template11/shop')} className="px-8 py-3 text-sm tracking-[0.15em] uppercase" style={{ backgroundColor: '#D97706', border: 'none', color: '#1C1917', fontFamily: "'Oswald', sans-serif", fontWeight: 600, cursor: 'pointer' }}>
                                    Shop Now
                                </button>
                            </div>
                        ) : (
                            <div className="space-y-6">
                                {filtered.map(order => (
                                    <div key={order.id} style={{ backgroundColor: '#292524', border: '1px solid #44403C' }}>
                                        {/* Order Header */}
                                        <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center p-4 gap-2" style={{ borderBottom: '1px solid #44403C' }}>
                                            <div>
                                                <p className="text-sm font-semibold" style={{ color: '#FAFAF9', fontFamily: "'Oswald', sans-serif", letterSpacing: '1px' }}>{order.id}</p>
                                                <p className="text-xs mt-1" style={{ color: '#A8A29E' }}>{order.date}</p>
                                            </div>
                                            <div className="flex items-center gap-2 px-3 py-1" style={{ border: `1px solid ${order.statusColor}` }}>
                                                <span style={{ color: order.statusColor }}>{getStatusIcon(order.status)}</span>
                                                <span className="text-xs font-semibold uppercase tracking-wider" style={{ color: order.statusColor }}>{order.status}</span>
                                            </div>
                                        </div>
                                        {/* Items */}
                                        <div className="p-4">
                                            {order.items.map((item, i) => (
                                                <div key={i} className={`flex gap-4 ${i > 0 ? 'mt-4 pt-4' : ''}`} style={i > 0 ? { borderTop: '1px solid #44403C' } : {}}>
                                                    <div className="w-16 h-20 overflow-hidden flex-shrink-0"><img src={item.image} alt={item.name} className="w-full h-full object-cover" /></div>
                                                    <div className="flex-1">
                                                        <h3 className="text-sm font-semibold" style={{ color: '#FAFAF9' }}>{item.name}</h3>
                                                        <p className="text-xs mt-1" style={{ color: '#A8A29E' }}>Size: {item.size} | Qty: {item.qty}</p>
                                                        <p className="text-sm font-semibold mt-1" style={{ color: '#D97706' }}>{`\u20B9${item.price.toLocaleString('en-IN')}`}</p>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                        {/* Footer */}
                                        <div className="flex justify-between items-center p-4" style={{ borderTop: '1px solid #44403C' }}>
                                            <span className="text-sm font-semibold" style={{ fontFamily: "'Oswald', sans-serif", color: '#FAFAF9' }}>Total: <span style={{ color: '#D97706' }}>{`\u20B9${order.total.toLocaleString('en-IN')}`}</span></span>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                </main>

                <Footer />
            </div>
        </>
    );
};

export default Orders11;
